export default __webpack_public_path__ + "static/media/t8.9670463d.jpg";